import { Node, mergeAttributes } from '@tiptap/core';

export const VideoNode = Node.create({
    name: 'video',
    group: 'block',
    atom: true,
    draggable: true,
    selectable: true,

    addAttributes() {
        return {
            src: { default: null },
            controls: { default: true },
            autoplay: { default: false },
            loop: { default: false },
            muted: { default: false },
            playsinline: { default: true },
            poster: { default: null },
            width: { default: '100%' },
            style: { default: 'max-width:600px; margin:10px 0;' },
        };
    },

    parseHTML() {
        return [{ tag: 'video[src]' }];
    },

    renderHTML({ HTMLAttributes }) {
        const a = { ...HTMLAttributes };

        // pull src off the attrs we’ll render on <video>
        const src = a.src;
        delete a.src;

        // drop false/nulls
        Object.keys(a).forEach(k => {
            if (a[k] === false || a[k] == null) delete a[k];
        });

        // ensure booleans are present only when true
        ['autoplay', 'loop', 'muted', 'playsinline'].forEach(k => {
            if (a[k] === true) a[k] = '';
            else delete a[k];
        });

        // force visible controls + quick metadata for first frame
        a.controls = '';
        if (!a.preload) a.preload = 'metadata';
        // if loading from another origin, this helps with CORS:
        // a.crossorigin = 'anonymous'

        // render with src directly on <video>
        a.src = src || '';

        return ['video', a];
    },

    addCommands() {
        return {
            insertVideo:
                attrs =>
                ({ commands }) => {
                    return commands.insertContent({ type: this.name, attrs });
                },
        };
    },
});
